import { CatInputField } from '@blocks-react/components/InputField';
import { useInputController } from '../../../../hooks/form-controllers';
interface Props {
  name: string;
  label: string;
  placeholder: string;
  required?: boolean;
  disabled?: boolean;
  isError?: boolean;
}

export const AssociatedDealerInput = ({
  name,
  label,
  placeholder,
  required = false,
  disabled = false,
  isError = false,
}: Props) => {
  const { inputField } = useInputController({ name });
  return (
    <CatInputField
      {...inputField}
      fieldId={name}
      name={name}
      label={label}
      title={label}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      data-testid={`${name}-test`}
      type="text"
      className="data-cs-mask"
      status={isError ? 'error' : undefined}
    />
  );
};
